import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import './FormNavigation.scss';

interface FormNavigationProps {
  activeTab: 'basic' | 'advanced' | 'additions';
  onTabChange: (tab: 'basic' | 'advanced' | 'additions') => void;
}

const FormNavigation: React.FC<FormNavigationProps> = ({
  activeTab,
  onTabChange
}) => {
  return (
    <div className="form-navigation">
      <ButtonGroup className="nav-button-group">
        <Button
          variant={activeTab === 'basic' ? 'primary' : 'outline-secondary'}
          className={`nav-button ${activeTab === 'basic' ? 'active' : ''}`}
          onClick={() => onTabChange('basic')}
        >
          <span className="nav-text">Información Básica</span>
        </Button>
        <Button
          variant={activeTab === 'advanced' ? 'primary' : 'outline-secondary'}
          className={`nav-button ${activeTab === 'advanced' ? 'active' : ''}`}
          onClick={() => onTabChange('advanced')}
        >
          <span className="nav-text">Configuración Avanzada</span>
        </Button>
        <Button
          variant={activeTab === 'additions' ? 'primary' : 'outline-secondary'}
          className={`nav-button ${activeTab === 'additions' ? 'active' : ''}`}
          onClick={() => onTabChange('additions')}
        >
          <span className="nav-text">Agregados y Opciones</span>
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default FormNavigation;
